var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavVIncidenciasActive = function SvgNavVIncidenciasActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_v_incidencias_active_svg__Capa_2",
    viewBox: "0 0 37.68 34.22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_v_incidencias_active_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.31 3.36 1.46 25.63c-2.01 3.48.5 7.84 4.53 7.84H31.7c4.02 0 6.54-4.35 4.53-7.84L23.36 3.36c-2.01-3.48-7.04-3.48-9.05 0ZM18.84 10.1v8.25M18.84 23.85v2.75",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavVIncidenciasActive;